
import Component, { mixins } from "vue-class-component"
import VerzehrartLogic from "@/logic/bestellung_neu/verzehrart_logic"
import FilialeHeader from "../custom/FilialeHeader.vue"
import Calculator from "../mixins/Calculator.vue"
import ErrorBox from "../custom/ErrorBox.vue"
import NichtGueltig from "../custom/NichtGueltig.vue"

@Component({ components: { FilialeHeader, ErrorBox, NichtGueltig } })
export default class Verzehrart extends mixins(Calculator) {
  logic: VerzehrartLogic = new VerzehrartLogic()

  mounted() {
    this.logic.init()
  }

  weiter() {
    this.logic.weiter()
  }
}
